<template>
    <div class="database-view" v-if="section">
        <div class="yq-news-section-list-page-head">
            {{section.name}}
        </div>
        <div class="clear"></div>
        <div class="gengduo" v-if="datasource">
            <news-query :datasource="datasource" @search="search">
                <template slot="fields">
                    <el-form-item label="编审状态">
                        <el-select v-model="extraSearchForm.edited" clearable style="width: 100px"
                                   @change="onExtraSearchFormEditedChange">
                            <el-option :value="false" label="未编"></el-option>
                            <el-option :value="true" label="已编"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="编审结果">
                        <el-select v-model="extraSearchForm.deleted" clearable style="width: 100px"
                                   @change="onExtraSearchFormDeletedChange">
                            <el-option :value="false" label="采用"></el-option>
                            <el-option :value="true" label="删除"></el-option>
                        </el-select>
                    </el-form-item>
                </template>
            </news-query>
            <div v-if="data">
                <news-list :data="data.content" :datasource="datasource" view-name="list"
                           @show-details="showDetails" ops-width="120" fix-ops>
                    <el-table-column label="编审结果" width="80" fixed="right">
                        <span slot-scope="scope">
                            {{scope.row.source._editNotifyData.deleted===true?'删除':(scope.row.source._editNotifyData.deleted===false?'采用':'未编')}}
                        </span>
                    </el-table-column>
                    <el-table-column label="编审用户" width="80" fixed="right">
                        <span slot-scope="scope">
                            {{scope.row.source._editNotifyData.editorUser?scope.row.source._editNotifyData.editorUser.name:''}}
                        </span>
                    </el-table-column>
                    <el-table-column label="编审时间" width="120" fixed="right">
                        <pretty-date-time slot-scope="scope"
                                          :value="scope.row.source._editNotifyData.editTime"></pretty-date-time>
                    </el-table-column>
                    <template slot="ops" slot-scope="scope">
                        <el-link
                                v-if="!scope.row.source._editNotifyData.editTime || scope.row.source._editNotifyData.deleted"
                                @click="retainRow(scope.row)">采用
                        </el-link>
                        <el-link v-if="!scope.row.source._editNotifyData.deleted" @click="deleteRow(scope.row)">删除
                        </el-link>
                        <el-link v-if="!scope.row.sended" @click="sendRow(scope.row)">推送</el-link>
                        <el-link v-else disabled>已推送</el-link>
                    </template>
                </news-list>
            </div>
            <div class="magin10"></div>
            <div class="foot" v-if="data">
                <el-pagination
                        layout="prev, pager, next" background
                        :total="data.totalElements" :current-page="data.number+1"
                        @current-change="fetchData($event)">
                </el-pagination>
            </div>
        </div>
        <div class="gengduo" v-else>
            <span>该栏目尚未配置完成</span>
        </div>
    </div>
</template>

<script>
    import newsSectionEditService from '../../service/news-section-edit'
    import datasourceConfigService from '../../service/datasource-config'
    import sectionService from '../../service/section'
    import NewsList from './NewsList'
    import NewsQuery from './NewsQuery'
    import qs from 'qs'

    export default {
        name: "NewsSectionEditList",
        props: {
            sectionId: Number
        },
        components: {NewsList, NewsQuery},
        data() {
            return {
                section: null,
                datasource: null,
                data: null,
                extraSearchForm: {
                    edited: null,
                    deleted: null
                },
                searchParams: {
                    query: null,
                    edited: null,
                    deleted: null
                }
            }
        },
        created() {
            this.init()
        },
        watch: {
            sectionId() {
                this.init()
            }
        },
        methods: {
            async init() {
                this.section = (await sectionService.getSection(this.sectionId)).data
                if (!this.section.config) {
                    this.datasource = null
                    return
                }
                const sectionConfig = JSON.parse(this.section.config)
                if (!sectionConfig.tabs || sectionConfig.tabs.length === 0) {
                    this.datasource = null
                    return
                }
                const datasource = (await datasourceConfigService.getDatasourceConfig(sectionConfig.tabs[0].datasource.id)).data
                datasource.fields = JSON.parse(datasource.fields)
                this.datasource = datasource
                await this.fetchData(1)
            },
            async fetchData(page) {
                const params = {
                    sectionId: this.sectionId,
                    page: page - 1,
                    size: 10
                }
                Object.assign(params, this.searchParams)
                const response = await newsSectionEditService.listNews(params)
                if (response.data.content.length > 0) {
                    const docIds = response.data.content.map(item => item.id)
                    const checkResult = (await newsSectionEditService.checkSectionNewsNotifications(this.sectionId, docIds)).data
                    response.data.content.forEach(item => {
                        item.sended = checkResult.includes(item.id)
                    })
                }
                this.data = response.data
            },
            search(query) {
                this.query = query
                this.searchParams.edited = this.extraSearchForm.edited
                this.searchParams.deleted = this.extraSearchForm.deleted
                this.fetchData(1)
            },
            showDetails(id) {
                const url = document.location.origin + document.location.pathname + '#/main/news-details'
                const params = {
                    id,
                    datasourceId: this.datasource.id,
                }
                window.open(url + '?' + qs.stringify(params, {arrayFormat: 'repeat'}), '_blank')
            },
            retainRow(row) {
                newsSectionEditService.updateNews({sectionId: this.sectionId}, {
                    id: row.id,
                    source: {
                        _editNotifyData: {
                            deleted: false
                        }
                    }
                }).then(() => {
                    this.fetchData(this.data.number + 1)
                    this.$message({
                        type: 'success',
                        message: '保留成功!'
                    })
                }).catch(() => {
                    this.$message({
                        type: 'error',
                        message: '保留失败!'
                    })
                })
            },
            deleteRow(row) {
                this.$confirm('确定要删除该记录吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    newsSectionEditService.updateNews({sectionId: this.sectionId}, {
                        id: row.id,
                        source: {
                            _editNotifyData: {
                                deleted: true
                            }
                        }
                    }).then(() => {
                        this.fetchData(this.data.number + 1)
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'error',
                            message: '删除失败!'
                        })
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                })
            },
            onExtraSearchFormEditedChange(edited) {
                if (!edited) {
                    this.extraSearchForm.deleted = null
                }
            },
            onExtraSearchFormDeletedChange(deleted) {
                if (deleted === true || deleted === false) {
                    this.extraSearchForm.edited = true
                }
            },
            sendRow(row) {
                this.$confirm('确定要推送该记录吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    newsSectionEditService.addSectionNewsNotification({
                        sectionId: this.sectionId,
                        docId: row.id
                    }).then(() => {
                        row.sended = true
                        this.$message({
                            type: 'success',
                            message: '推送成功!'
                        })
                    }).catch((error) => {
                        if (error.response && error.response.data && error.response.data.message) {
                            this.$message({
                                type: 'error',
                                message: '推送失败: ' + error.response.data.message
                            })
                        } else {
                            this.$message({
                                type: 'error',
                                message: '推送失败: ' + error
                            })
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消推送'
                    });
                })
            },
        }
    }
</script>

<style scoped>

</style>
